import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "@needl-ai/common/lib/axios";

const QUERY_KEY = "feed-definition";

export type BoardDocument = {
  id: string;
  bucket: string;
  key: string;
  metadata: {
    name: string;
    mime_type: string;
  };
  status: "PROCESSING" | "COMPLETED" | "FAILED";
  type: "DOCUMENT";
  deeplink?: string;
  access_key?: string;
};

export type FeedData = {
  name: string;
  description: string | null;
  group: string;
  publish: boolean;
  parent_id: string | null;
  created_at: string;
  enabled: boolean;
  creation_source: string;
  keywords: {
    include: string[];
    exclude: string[];
  };
  sources: Record<string, unknown>;
  secondary_sources: Record<string, unknown>;
  date_range: string;
  documents: BoardDocument[];
};

export const useFetchFeed = (
  boardId: string,
  refetchInterval?: number | false,
  enabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEY, boardId],
    queryFn: async (): Promise<FeedData> => {
      const response = await axiosInstance.get(`/boards/${boardId}/v2`);
      return response.data.results;
    },
    enabled: !!boardId && enabled,
    ...(refetchInterval && { refetchInterval }),
  });
};
